import { getLanguage } from 'rde-view-common/scripts/functions';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from '../locales/en';
import ja from '../locales/ja';

Vue.use(VueI18n);

/**
 * i18n
 */
export default ({ app }) => {
  const browserLocale = getLanguage();
  const locale = browserLocale || 'en';
  app.i18n = new VueI18n({
    locale,
    fallbackLocale: 'en',
    messages: { ja, en }
  });
};
